import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ObservationService } from "../../observation/service/observation.service";
import { DialogGalleryComponent } from "../dialog-gallery/dialog-gallery.component";
import { AuthService } from "../../auth/service/auth.service";

export interface CardContent {
  card_id: number;
  card_id_1: number;
  card_name: string;
  card_id_2: number | null;
  card_name_2: string | null;
  card_value_1: string | null;
  card_date: string | null;
  card_value_2: string | null;
  card_user_id: number | null;
  card_username: string | null;
  card_user_image_url: string | null;
  card_image_url: string | null;
  flag_1: boolean | null;
}

@Component({
  selector: "app-template-row-edit-obs",
  templateUrl: "./template-row-edit-obs.component.html",
  styleUrls: ["./template-row-edit-obs.component.css"],
})
export class TemplateRowEditObsComponent implements OnInit {
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private observationService: ObservationService,
    private authService: AuthService
  ) { }

  @Input() cardContent!: CardContent;
  @Input() route!: string;
  @Input() role!: string;


  @Output() deleteChange = new EventEmitter<Boolean>();


  checked = false;
  indeterminate = false;
  labelPosition: "before" | "after" = "after";
  disabled = false;

  ngOnInit(): void { }

  time_ago(time: any) {
    switch (typeof time) {
      case "number":
        break;
      case "string":
        time = +new Date(time);
        break;
      case "object":
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, "segundos", 1], // 60
      [120, "1 minuto atrás", "1 minuto desde ahora"], // 60*2
      [3600, "minutos", 60], // 60*60, 60
      [7200, "1 hora atrás", "1 hora desde ahora"], // 60*60*2
      [86400, "horas", 3600], // 60*60*24, 60*60
      [172800, "Ayer", "Mañana"], // 60*60*24*2
      [604800, "días", 86400], // 60*60*24*7, 60*60*24
      [1209600, "Última semana", "Siguiente semana"], // 60*60*24*7*4*2
      [2419200, "semanas", 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, "Último mes", "Siguiente mes"], // 60*60*24*7*4*2
      [29030400, "meses", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, "Último año", "Siguiente año"], // 60*60*24*7*4*12*2
      [2903040000, "años", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, "Último siglo", "Siguiente siglo"], // 60*60*24*7*4*12*100*2
      [58060800000, "siglos", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
    var seconds = (+new Date() - time) / 1000,
      token = "atrás",
      list_choice = 1;

    if (seconds == 0) {
      return "Justo ahora";
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = "desde ahora";
      list_choice = 2;
    }
    var i = 0,
      format;
    while ((format = time_formats[i++]))
      if (typeof format[0] == "number") {
        if (seconds < format[0]) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      }

    return time;
  }

  fnItem(id: number | string) {
    const _router = "/" + this.route;
    // this.router.navigate([_router, id]);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_router, id]).then(() => {
      })
    })
  }

  fnEditItem(id: number | string) {
    const _router = "/" + this.route + "-edit";
    // this.router.navigate([_router, id]);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_router, id]).then(() => {
      })
    })
  }

  fnDeleteItem(id: number | string) {

    this.observationService.deleteObservation(id).subscribe(
      (_resp) => {

        const condition = _resp.success;
        if (condition) {
          this.deleteChange.emit(true);
        } else {
          this.deleteChange.emit(false);
        }

      }
    );

  }

  // putIsPublic($event: any) {


  //   const _req = {
  //     variety_observation_id: this.cardContent.card_id,
  //     is_public: this.cardContent.flag_1
  //   };

  //   console.log({ _req: _req });


  //   this.observationService
  //     .patchIsPublic(_req)
  //     .subscribe();
  // }


  putIsPublic($event: any) {
    const _variety_observation_id = this.cardContent.card_id;
    const _is_public = this.cardContent.flag_1;

    this.observationService
      .patchIsPublic(_variety_observation_id, _is_public)
      .subscribe();
  }

  fnIsRole(role: string) {
    return this.authService.isRole(role);
  }

}
